import { Dimensions, StyleSheet } from "react-native";
import { AD_BANNER_HEIGHT } from "../AdBanner";

const vh = Dimensions.get("window").height;

const YOYO_SIZE = vh / 4;

const PADDING_VERTICAL = 12;

export const styles = StyleSheet.create({
  absolute: {
    position: "absolute",
    top: 0,
  },
  strap: {
    width: 4,
  },
  yoyoCircle: {
    width: YOYO_SIZE,
    height: YOYO_SIZE,
    overflow: "hidden",
    borderRadius: YOYO_SIZE,
    // FYI: https://www.bad-company.jp/react-native-shadow
    shadowColor: "#000",
    shadowOffset: {
      width: 1,
      height: 1,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 4,
  },
  yoyoImage: {
    width: YOYO_SIZE,
    height: YOYO_SIZE,
  },
});

export const OFFSET_DEFAULT = PADDING_VERTICAL;
export const OFFSET_PLAYING =
  vh - YOYO_SIZE - PADDING_VERTICAL * 2 - AD_BANNER_HEIGHT;
